import React from 'react';
import { useLabel } from '@react-aria/label';
import { mergeProps } from '@react-aria/utils';
import { omit } from '../../utils/index.js';
import { Label } from '../label/index.js';
import { VisuallyHidden } from '../visually-hidden/index.js';
import { FormElement } from './form.styles.js';
export const Form = React.forwardRef(({ noValidate = true, label, children, dataAutomation = 'form', ...props }, ref) => {
    const { labelProps, fieldProps } = useLabel({
        label,
        'aria-labelledby': props['aria-labelledby'],
        id: props.id,
    });
    return (React.createElement(FormElement, { ref: ref, noValidate: noValidate, ...mergeProps(props, fieldProps), "data-automation": dataAutomation },
        label && (React.createElement(VisuallyHidden, null,
            React.createElement(Label, { ...omit(labelProps, 'color') }, label))),
        children));
});
//# sourceMappingURL=form.component.js.map